import * as React from "react";
export class HeadingNavigation extends React.PureComponent {
    render() {
        return (
        // TODO: Reviewer - Should main div be nav or heading?
        React.createElement("div", { className: "rj-aggregate-navigation-wrapper" },
            React.createElement("button", { className: "rj-aggregate-navigation-back-btn", onClick: this.props.goBack },
                React.createElement("span", { className: "icon i-16 i-o-arrow-back rj-aggregate-navigation-arrow" })),
            this.props.info.name !== undefined ?
                React.createElement("div", { className: "rj-aggregate-navigation-event-info-wrapper" },
                    React.createElement("div", { className: "rj-aggregate-navigation-event-name" },
                        this.props.info.count,
                        " ",
                        this.props.info.name),
                    React.createElement("div", { className: "rj-aggregate-navigation-event-time" },
                        this.props.dict.startedAt,
                        " ",
                        this.props.info.startingTime))
                : React.createElement("div", { className: "rj-aggregate-navigation-event-info-wrapper" })));
    }
}
//# sourceMappingURL=HeadingNavigation.js.map